// import API from 'services/API';
import API from 'services/TAPS_API';

export default function sendCertificate(data) {
  return API.request({
    method: 'POST',
    url: '/irud/registration',
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
}
